<template>
    <div v-if="showA2HS">
        <base-dialog v-if="modalVisible" v-model="modalVisible" :okFn="addToHomeScreen" :cancelFn="saveNotAddingToHomeScreen" :okBtnText="$t('a2hs.modal-install-btn')">
            <div class="row">
                <div class="col-4 d-flex">
                    <img :src="getAppIcon" class="img-fluid m-auto" alt="App icon"/>
                </div>
                <div class="col-8">
                    <p>{{ $t('a2hs.modal-message', { platform: getPlatformName }) }}</p>
                </div>
            </div>
        </base-dialog>
        <div class="install-app-block" @click="addToHomeScreen" v-if="deferredPrompt || deviceIsAllowedIOS" :class="{ 'animate': animateActive, 'shadow': shadow, 'white': white }">
          <img :src="getAppIcon" class="d-inline-block mr-2"/>
          <span class="d-inline-block" v-if="!small">{{ $t('a2hs.modal-install-btn') }} app</span>
					<base-icon :blue="!white" :white="white" src="/static-appopensalud/img/icons/install-browser.svg" class="d-inline-block ml-2" v-else alt="Instalar"/>
        </div>
				<div class="safari-tooltip" v-if="safariTooltipVisible" v-click-outside="() => safariTooltipVisible = false">
					<span v-html="$t('a2hs.safari-tooltip', { shareIconImg })"></span>
				</div>
    </div>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue'
import { PWA_INSTALLED_COOKIE_NAME } from '@/constants/cookies'
import { getPlatformName, OPENLEGAL_PLATFORM_NAME, OPENSALUD_PLATFORM_NAME } from '@/constants/platformNames'
import { hideSmartsuppChat } from '@/helpers/ui.helpers'

export default {
    name: 'AddToHomeScreen',
    components: {
        BaseDialog
    },
    props: {
        showPromptOnLoad: {
            type: Boolean,
            default: false
        },
				small: {
					type: Boolean,
					default: false
				},
				animate: {
					type: Boolean,
					default: false
				},
				shadow: {
					type: Boolean,
					default: false
				},
				white: {
					type: Boolean,
					default: false
				}
    },
    data () {
        return {
            modalVisible: false,
            deferredPrompt: null,
            getPlatformName: getPlatformName(),
						mounted: false,
						safariTooltipVisible: false,
						shareIconImg: '<img src=\'/static-appopensalud/img/icons/morillas-svg-icons/primary/share.svg\' class="safari-tooltip-icon"></img>',
						plusIconImg: '<img src=\'/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg\' class="safari-tooltip-icon"></img>'
        }
    },
    methods: {
        addToHomeScreen () {
						if (this.deviceIsAllowedIOS) {
							this.safariTooltipVisible = true
							setTimeout(() => {
								this.safariTooltipVisible = false
							}, 6000)
						} else {
							// Show the prompt
							this.deferredPrompt.prompt()
							// Wait for the user to respond to the prompt
							this.deferredPrompt.userChoice
								.then((choiceResult) => {
										if (choiceResult.outcome === 'accepted') {
												window.$cookies.set(PWA_INSTALLED_COOKIE_NAME, false, 365, '/', this.$helpers.getFirstLevelDomain())
										} else {
												window.$cookies.set(PWA_INSTALLED_COOKIE_NAME, false, 30, '/', this.$helpers.getFirstLevelDomain())
										}
										this.modalVisible = false
										this.deferredPrompt = null
								})
						}
        },
        saveNotAddingToHomeScreen () {
            this.modalVisible = false
            this.deferredPrompt = null
            window.$cookies.set(PWA_INSTALLED_COOKIE_NAME, false, 30, '/', this.$helpers.getFirstLevelDomain())
        }
    },
		watch: {
			safariTooltipVisible (val) {
				if (val) {
					hideSmartsuppChat()
				}
			}
		},
    computed: {
        getAppIcon () {
            return `/static-appopensalud/img/favicons/${this.getPlatformName === OPENLEGAL_PLATFORM_NAME ? this.getPlatformName : OPENSALUD_PLATFORM_NAME}/dark-theme/favicon-32x32.png`
        },
				animateActive () {
					return this.animate && this.mounted
				},
				deviceIsAllowedIOS () {
					return (!window.navigator.standalone && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
				},
				showA2HS () {
					// Check device is iOS with Safari and app is not running in standalone mode
					return this.deferredPrompt || this.deviceIsAllowedIOS
				}
    },
    mounted () {
        // Before install prompt opening modal
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault()
            // Stash the event so it can be triggered later.
            this.deferredPrompt = e
            // Update UI to notify the user they can add to home screen
            if (this.showPromptOnLoad && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.$cookies.get(PWA_INSTALLED_COOKIE_NAME) !== 'true' && window.$cookies.get(PWA_INSTALLED_COOKIE_NAME) !== 'false') {
                this.modalVisible = true
            }
        })

				this.mounted = true
    }
}
</script>

<style lang="scss">
    .install-app-block {
        cursor: pointer;
        background-color: $blue;
				color: $white;
				&.white {
					background-color: transparent;
					border: 1px solid $white;
				}
        width: fit-content;
        padding: 0.5rem 1.75rem;
        border-radius: $border-radius;
        transition: all 0.5s;

				@include mobile {
					font-size: 12.25px;
				}

        &:hover {
            border: 1px solid white;
            font-size: 1.05rem;
            transition: all 0.5s;
        }

				&.shadow {
					box-shadow: $custom-shadow-sm;
				}

        img {
            width: 20px;
						vertical-align: text-bottom;
        }

				.animate {
					animation-duration: 1s;
					animation-name: animate-fade;
					animation-timing-function: cubic-bezier(0.26, 0.53, 0.74, 1.48);
					animation-fill-mode: backwards;
					animation-name: animate-glow;
					animation-timing-function: ease;

					@keyframes animate-glow {
						0% {
							opacity: 0;
							filter: brightness(3) saturate(3);
							transform: scale(0.8, 0.8);
						}
						100% {
							opacity: 1;
							filter: brightness(1) saturate(1);
							transform: scale(1, 1);
						}
					}
				}

				span {
					color: $white;
				}
    }

		.safari-tooltip {
			position: fixed;
			bottom: 15px;
			left: 0;
			right: 0;
			padding: 1rem;
			background-color: $white;
			color: $black;
			text-align: center;
			font-size: 0.9rem;
			z-index: 9999;
			border-radius: $border-radius;
			margin: {
				left: 1rem;
				right: 1rem;
			}

			span {
				display: inline-block;
				width: 100%;
				max-width: 500px;
				text-align: left;
			}

			&:after {
				content: '';
				position: fixed;
				bottom: -5px;
				left: 50%;
				margin-left: -11px;
				border-width: 11px;
				border-style: solid;
				border-color: $white transparent transparent transparent;
			}
			
			.safari-tooltip-icon {
				width: 19px;
				height: 19px;
			}
		}
</style>


// WEBPACK FOOTER //
// src/components/utils/AddToHomeScreen.vue